import { useEffect } from "react";
import "./toastViewport.scss";

const TOAST_MARGIN = 16;
const TOAST_CONTAINERS = [
  ".notification-container--top-right",
  ".notification-container--top-left",
  ".notification-container--top-center",
  ".notification-container--top-full",
  ".notification-container--mobile-top",
].join(",");

/**
 * The toast sits in `.notification-container--top-right` (absolute, top: 20px)
 * inside a fixed overlay pinned to the iframe, not to the visible screen.
 * parentScrollInfo moves that container to the top of the area the user can see.
 */
const ToastViewportPosition = () => {
  useEffect(() => {
    if (window.self === window.top) return;

    const place = (parentScroll: number, iframeTop: number) => {
      const visibleTop = Math.max(parentScroll - iframeTop, 0) + TOAST_MARGIN;
      const top = `${visibleTop}px`;
      document.documentElement.style.setProperty("--ea-toast-top", top);
      document.querySelectorAll(TOAST_CONTAINERS).forEach((node) => {
        (node as HTMLElement).style.top = top;
      });
    };

    const handleMessage = (event: MessageEvent) => {
      const raw = typeof event.data === "string" ? event.data : "";
      if (!raw.startsWith("parentScrollInfo::")) return;

      const parts = raw.split("::");
      if (parts.length < 4) return;

      const parentScroll = parseFloat(parts[1]);
      const iframeTop = parseFloat(parts[3]);
      if (isNaN(parentScroll) || isNaN(iframeTop)) return;

      place(parentScroll, iframeTop);
    };

    window.addEventListener("message", handleMessage);
    window.parent.postMessage("updateScrollPosition::", "*");

    return () => {
      window.removeEventListener("message", handleMessage);
      document.documentElement.style.removeProperty("--ea-toast-top");
      document.querySelectorAll(TOAST_CONTAINERS).forEach((node) => {
        (node as HTMLElement).style.top = "";
      });
    };
  }, []);

  return null;
};

export default ToastViewportPosition;
